export default function Reports() {
  return <h3>Reports</h3>;
}
